export var PartnerLogo;
(function (PartnerLogo) {
    PartnerLogo["Asurion"] = "asurion-logo.svg";
    PartnerLogo["Att"] = "att-logo.svg";
    PartnerLogo["Claro"] = "claro-logo.svg";
    PartnerLogo["Cox"] = "cox-logo.svg";
    PartnerLogo["Cricket"] = "cricket-logo.svg";
    PartnerLogo["Directv"] = "directv-logo.svg";
    PartnerLogo["Koodo"] = "koodo-logo.svg";
    PartnerLogo["Sprint"] = "sprint-logo.svg";
    PartnerLogo["Telcel"] = "telcel-logo.svg";
    PartnerLogo["Telus"] = "telus-logo.svg";
    PartnerLogo["UsCellular"] = "uscellular-logo.svg";
    PartnerLogo["Verizon"] = "verizon-logo.svg";
})(PartnerLogo || (PartnerLogo = {}));
